import { useEffect } from 'react'
import { isString } from 'lodash'
import { image } from '../../../../../utils/data/baseUrl'
import useStateControls from '../../../../../hooks/useStateControls'
import useServiceData from '../../../../../hooks/useServiceData'
import { useModal } from '../../../../../hooks/useModal'
import { useFeatureToggle } from '../../../../../hooks/useFeatureToggle'
import { useOnboarding } from '../../../../../redux/reducer/content'
import { useApplicationCallbacks } from '../../../../../providers/application-callbacks'
import { BUTTONS, IMAGE, TEXT, TITLE } from '../../../../modals/universalModal'
import { FRIENDS } from '../../../../../constants/shared/states/names'
import content from '../../constants/content'

const {
  postcard: { modalForId },
} = content

export default function useMarch8ModalCongratulate() {
  const { get, save } = useServiceData()
  const { addModal, closeModal } = useModal()
  const { setState } = useStateControls()
  const callbacks = useApplicationCallbacks()
  const gameTamagotchiPromo8March = useFeatureToggle('gameTamagotchiPromo8March')
  const { marchModalsVisible } = useOnboarding()

  const openIdModal = () => {
    closeModal('all')
    addModal({
      type: 'wishModal',
      props: {
        ...modalForId,
        onSubmit({ id } = {}) {
          isString(id) && callbacks.getWishUserData(id)
        },
      },
    })
  }

  useEffect(() => {
    if (!gameTamagotchiPromo8March || !marchModalsVisible) return

    const modalsData = get('modalsData') ?? {}

    if (!modalsData?.march8ModalCongratulate) {
      addModal({
        type: 'universalModal',
        props: {
          modalProps: {
            wrapper: { isFullPage: false },
            modifier: ['noFullNoScroll', 'width-image-full'],
          },
          components: [
            {
              list: [
                {
                  type: IMAGE,
                  props: {
                    modifier: 'width-full',
                    img: image('8march/congratulate8march.png'),
                  },
                },
                {
                  type: TITLE,
                  props: {
                    modifier: 'padding-no',
                    value: 'march8ModalCongratulateContent.title',
                  },
                },
                {
                  type: TEXT,
                  props: {
                    value: 'march8ModalCongratulateContent.text',
                  },
                },
                {
                  type: BUTTONS,
                  props: {
                    buttons: [
                      {
                        text: 'march8ModalCongratulateContent.button1.text',
                        disposable: true,
                        onClick: openIdModal,
                      },
                      {
                        text: 'march8ModalCongratulateContent.button2.text',
                        className: 'custom-button_gray',
                        disposable: true,
                        onClick() {
                          closeModal('all')
                          setState(FRIENDS)
                        },
                      },
                    ],
                  },
                },
              ],
            },
          ],
        },
      })
      save('modalsData', { ...modalsData, march8ModalCongratulate: true })
    }
  }, [gameTamagotchiPromo8March, marchModalsVisible])
}
